export default __webpack_public_path__ + "216b877181308aa9017aed21351bc005.png";